import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircleIcon, ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: <>
        No. Está escrito para quien nunca tocó la resina. Cada paso explicado{' '}
        <strong className="text-[#2563EB]" data-id="element-73">desde cero</strong> con el por qué
        detrás de cada acción.
      </>
}, {
  q: '¿El pago es seguro?',
  a: <>
        Sí, 100%. El pago se procesa a través de{' '}
        <strong className="text-[#2563EB]" data-id="element-74">Mercado Pago</strong>, la plataforma
        de pagos más segura de Latinoamérica. Tus datos están protegidos con
        encriptación de nivel bancario.
      </>
}, {
  q: '¿Qué medios de pago aceptan?',
  a: <>
        Aceptamos{' '}
        <strong className="text-[#2563EB]" data-id="element-75">
          todas las tarjetas de crédito y débito
        </strong>{' '}
        (Visa, Mastercard, OCA, etc.), transferencia bancaria, y también podés
        pagar en efectivo por{' '}
        <strong className="text-[#2563EB]" data-id="element-76">Abitab, RedPagos</strong> y otras
        redes de cobranza en todo Uruguay.
      </>
}, {
  q: '¿Qué pasa si no me llega el acceso?',
  a: <>
        Revisá tu carpeta de spam o correo no deseado. Si aún así no lo
        encontrás, escribinos a{' '}
        <strong className="text-[#2563EB]" data-id="element-77">joyasconresina44@gmail.com</strong> y
        te lo reenviamos de inmediato. Respondemos en menos de 24 horas.
      </>
}, {
  q: '¿Qué pasa si cometo un error?',
  a: <>
        El capítulo 14 tiene los{' '}
        <strong className="text-[#2563EB]" data-id="element-78">8 errores más comunes</strong> con
        solución completa. La mayoría tienen reparación sin perder la mesa ni
        los materiales.
      </>
}, {
  q: '¿Cómo recibo el libro?',
  a: <>
        PDF descargable. Recibís el link en tu email inmediatamente después del
        pago. <strong className="text-[#2563EB]" data-id="element-79">Acceso de por vida</strong> en
        celular, tablet o computadora.
      </>
}, {
  q: '¿Hay garantía?',
  a: <>
        Sí. 7 días de devolución total sin preguntas. Si no cumplió lo que
        prometió te devolvemos el 100% del dinero.
      </>
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-[36px] md:py-[64px] px-5 bg-[#F9FAFB] relative" data-id="element-80">
      <div className="max-w-3xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-[20px]" data-id="element-82">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-[10px] flex items-center justify-center gap-4" data-id="element-83">
            <HelpCircleIcon className="w-8 h-8 text-[#C9A84C]" data-id="element-84" />
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C]/30 mx-auto mt-[10px]" data-id="element-85"></div>
        </motion.div>

        <div className="space-y-0" data-id="element-86">
          {faqs.map((faq, index) => <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} key={index} className="border-b border-gray-200 last:border-0" data-id="element-87">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-[16px] flex items-center justify-between text-left hover:bg-gray-50/50 transition-colors" aria-expanded={openIndex === index} data-id="element-88">
                <span className="text-subtitle font-bold text-[#1A3A5C] pr-8" data-id="element-89">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-[20px] h-[20px] text-[#C9A84C] shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-90" />
              </button>
              <AnimatePresence initial={false} data-id="element-91">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-92">
                    <div className="pb-[16px] text-body-main text-gray-600 leading-relaxed" data-id="element-93">
                      <p className="max-w-3xl" data-id="element-94">{faq.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}